import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Clapperboard, ArrowRight, Lock } from "lucide-react";
import { ACADEMY_LOGO, ACADEMY_LOGO_H } from "../data/assets";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const GOLD = "#D4AF37";

// Public shareable highlight page (/highlight/:token) — only resolves when the player's parent consent flag is on.
export default function HighlightPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/highlights/public/${token}`).then(({ data: d }) => setData(d)).catch((e) => setErr(e?.response?.status === 403 ? "This highlight is private." : "Highlight not found."));
  }, [token]);
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white grain elite-carbon-bg flex flex-col" data-testid="highlight-page">
      <header className="px-6 py-4 flex items-center justify-between max-w-3xl mx-auto w-full">
        <img src={ACADEMY_LOGO_H} alt="The Next O Technical Academy" className="h-12 w-auto" />
        <button data-testid="highlight-page-cta" onClick={() => navigate("/")} className="inline-flex items-center gap-1.5 bg-[#C41E24] hover:bg-[#A0161D] text-white font-subheadings text-xs font-bold uppercase tracking-wider px-4 py-2.5 rounded-sm transition-colors">Join the Academy <ArrowRight size={13} /></button>
      </header>
      <main className="flex-1 flex items-center justify-center px-4 pb-16">
        <div className="w-full max-w-3xl">
          {err ? (
            <div data-testid="highlight-page-error" className="rounded-2xl border border-white/10 bg-[#111]/90 p-10 text-center">
              <Lock size={28} className="mx-auto mb-3 text-white/40" />
              <div className="font-headings text-2xl uppercase tracking-wide">{err}</div>
              <p className="text-sm text-white/45 mt-2">Highlights are shared only with a parent or guardian's consent.</p>
            </div>
          ) : !data ? <div className="text-center text-white/40">Loading…</div> : (
            <div className="rounded-2xl border overflow-hidden elite-card-halo" style={{ borderColor: `${GOLD}66`, background: "#0b0b0b" }}>
              <video data-testid="highlight-page-video" src={`${process.env.REACT_APP_BACKEND_URL}${data.video_url}`} controls autoPlay muted playsInline className="w-full aspect-video bg-black" />
              <div className="p-6 sm:p-8 flex flex-col sm:flex-row sm:items-end gap-5">
                <div className="flex-1 min-w-0">
                  <div className="inline-flex items-center gap-2 font-mono text-[10px] font-bold uppercase tracking-[0.3em]" style={{ color: GOLD }}><Clapperboard size={12} /> Coach Highlight</div>
                  <h1 data-testid="highlight-page-title" className="font-cover text-4xl sm:text-5xl uppercase leading-[0.9] mt-2">{data.player}'s <span style={{ color: GOLD }}>{data.title}</span></h1>
                  {data.note && <p className="text-base text-white/70 italic mt-3">“{data.note}” <span className="not-italic text-[10px] uppercase tracking-widest" style={{ color: GOLD }}>— Coach Barker</span></p>}
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mt-3">{[data.club_name, data.school_name].filter(Boolean).join(" · ")}{data.created_at ? ` · ${new Date(data.created_at).toLocaleDateString()}` : ""}</div>
                </div>
                <img src={ACADEMY_LOGO} alt="" className="w-24 h-auto shrink-0 drop-shadow-[0_8px_30px_rgba(212,175,55,0.35)]" />
              </div>
            </div>
          )}
          <p className="text-center text-[11px] uppercase tracking-[0.3em] text-white/35 mt-8">hub.nextosoccer.com · Master the Ball · Master the Game</p>
        </div>
      </main>
    </div>
  );
}
